module.exports = __webpack_public_path__ + "static/media/wheatfield@2x.d4ae6171.webp";